import React from "react";
import StripeCheckout from "react-stripe-checkout";
import axios from "axios";
import { toast } from "react-toastify";
import $ from 'jquery';
import ReCAPTCHA from "react-google-recaptcha";

import "react-toastify/dist/ReactToastify.css";

const ReactMarkdown = require('react-markdown');

toast.configure();

var state={
  captcha : false,
  val :''
}

var fakeState = {
  price:1,
  name: "",
  offering: "",
  description: "",
  captchaVal: ''
}

const StripeElement = (elem) => {
  const [product] = React.useState({
    name: fakeState.offering===""?"DPC DONATION":"DPC OFFERING",
    price: fakeState.price
  });

  async function handleToken(token, addresses) {
    const response = await axios.post(
      "/.netlify/functions/server/donate",
      { token, product: {
        name: fakeState.offering===0?"DONATION":"OFFERING",
        price: fakeState.price
      }, fakeState}
    );
    const { status } = response.data;
    if (status === "success") {
      toast("Thanks for supporting Downsview Church! Please check your email for more details", { type: "success" });
    } else {
      toast("Something went wrong, please contact June Wi at junewi98@gmail.com (Website Admin on About Us)", { type: "error" });
    }
  }

  function setToken(val){
    let fn = $("#name").val();
    let of = ($("#offering").val()!==undefined?Math.round($("#offering").val()):"");
    let d = ($("#purpose option:selected").val()!==undefined?elem.fields.purposeValues[$("#purpose option:selected").index()-1]:"") + "  " + ($("#purpose-spec").val()!==undefined?$("#purpose-spec").val():"");
    let p = Math.round($("#price").val() * 100)/100;
    let minval = elem.fields.minimumAmount ? elem.fields.minimumAmount : 5;

    if(fn==="" || p===0 || p < minval){
      alert("Please fill in all the required fields.");
      window.location.reload();
    }else{
      fakeState = {
        price: p,
        name: fn,
        offering: of,
        description: d,
        captchaVal: val
      }
      if(!state.captcha){
        $(".buttonholder").append("<button id='temp'></button>");
        $("#temp").trigger("click").remove();
        state = {
          captcha: true
        };
      }
    }
  }


  return (
    <div className="row stripe-payment">
      <div className="col-4 offset-4">
        <h1>{elem.fields.sectionTitle}</h1>
        <h6><ReactMarkdown source={elem.fields.sectionParagraph} escapeHtml={false}/></h6>
        <input type="text" className="stripe-payment-input" id="name" placeholder={elem.fields.fullNamePlaceholder} required/>
        <input type="number" className="stripe-payment-input" min="0" step="1" id="offering" placeholder={elem.fields.offeringNumberPlaceholder}/>
        {
          elem.fields.purpose &&
          [<select style={{padding:"6px"}} id="purpose" class="stripe-payment-input">
            <option value="" disabled selected>{elem.fields.purposePlaceholder}</option>
            {
              elem.fields.purpose.map((elems) =>  <option value={elems}> {elems} </option>)
            }
          </select>,
          <input type="text" className="stripe-payment-input" id="purpose-spec" placeholder={elem.fields.specifyPurposePlaceholder}/>]
        }
        <input type="number" className="stripe-payment-input" min="0.01" step="0.01" id="price" placeholder={elem.fields.amountPlaceholder} required/>
        <div className="captcha-text">
          {elem.fields.captchaText}
        </div>
        <StripeCheckout
          opened={()=>{  $(".Header-companyName").val(fakeState.offering===""?"Finalize Donation":"Finalize Offering"); }}
          name={"Finalize Donation/Offering"}
          description={elem.fields.warning}
          stripeKey="pk_live_refr1CaucbJBWRI6dtFyDJAs00280Odcck"
          token={handleToken}
          amount={0}
          currency='CAD'
          allowRememberMe={false}
          ComponentClass="div"
          panelLabel="Donate to DPC"
          reconfigureOnUpdate={false}
        >
        <div className="buttonholder"></div>
        <div style={{justifyContent:'center', display:'flex'}}>
          <ReCAPTCHA 
              sitekey="6Lekg_caAAAAAPsuCB1Oi06tCxI6xi4Fb7hF0xeO"
              onChange={setToken}
          />
        </div>
        </StripeCheckout>
      </div>
    </div>
  );
}

export default StripeElement;
